import React, { useState } from "react";
import PropTypes from "prop-types";
import { DateRangePicker, DateRange } from "react-date-range";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { Modal } from "flowbite-react";
import useScreenSize from "../useScreenSize";
import { useLocation } from "react-router-dom";
const DatePicker = (props) => {
  const { pathname } = useLocation();
  const dimensions = useScreenSize();
  const [open, setOpen] = useState(false);
  const [dateRange, setDateRange] = useState(props.state);
  const onClose = () => setOpen(false);

  // console.log(props.state);
  return (
    <>
      {pathname.includes("/entries") ||
      pathname.includes("/dashboard") ||
      pathname.includes("/transactions") ? (
        <button
          className="border hover:bg-[#F4F4F4] text-sm border-gray-400 whitespace-nowrap	rounded py-1.5 px-3"
          id="menu-button"
          aria-expanded="true"
          aria-haspopup="true"
          onClick={() => setOpen(true)}
        >
          {props.state[0].startDate || props.state[0].endDate ? (
            <div
              className="flex justify-center items-center gap-2 "
              onClick={() => setOpen(true)}
            >
              <img
                src={require("../../../assets/images/calender.svg")}
                alt=""
              />
              {new Date(props.state[0].startDate).getTime() ===
              new Date(props.state[0].endDate).getTime() ? (
                <p className="text-xs md:text-sm">
                  {new Date(props.state[0].startDate)
                    .toISOString()
                    .slice(0, 10)}
                </p>
              ) : (
                <>
                  {" "}
                  <p className="text-xs md:text-sm">
                    {new Date(props.state[0].startDate)
                      .toISOString()
                      .slice(0, 10)}
                  </p>
                  <p>-</p>
                  <p className="text-xs md:text-sm">
                    {new Date(props.state[0].endDate)
                      .toISOString()
                      .slice(0, 10)}
                  </p>
                </>
              )}
            </div>
          ) : (
            <p>{props.emptyState}</p>
          )}
        </button>
      ) : (
        <button
          className="flex justify-center items-center md:w-auto w-full gap-2 border hover:bg-[#F4F4F4] py-1 px-4 rounded-lg"
          onClick={() => setOpen(true)}
        >
          <img src={require("../../../assets/images/calender.svg")} alt="" />
          {new Date(props.state[0].startDate).getTime() ===
          new Date(props.state[0].endDate).getTime() ? (
            <p
              className={props.textSize ? props.textSize : "text-xs md:text-sm"}
            >
              {new Date(props.state[0].startDate).toISOString().slice(0, 10)}
            </p>
          ) : (
            <>
              {" "}
              <p
                className={
                  props.textSize ? props.textSize : "text-xs md:text-sm"
                }
              >
                {new Date(props.state[0].startDate)
                  ?.toISOString()
                  ?.slice(0, 10)}
              </p>
              <p>-</p>
              <p
                className={
                  props.textSize ? props.textSize : "text-xs md:text-sm"
                }
              >
                {new Date(props.state[0].endDate)?.toISOString()?.slice(0, 10)}
              </p>
            </>
          )}
        </button>
      )}

      <Modal
        placement={"center"}
        onHide={onClose}
        show={open}
        onClose={onClose}
      >
        {dimensions.width > 768 ? (
          <DateRangePicker
            editableDateInputs={false}
            onChange={(item) => setDateRange([item.selection])}
            // onChange={(item) => props.setState([item.selection])}
            moveRangeOnFirstSelection={false}
            showSelectionPreview={true}
            ranges={dateRange}
            months={1}
            direction="horizontal"
            rangeColors={["#FF6A3A"]}
            color="#FF6A3A"
          />
        ) : (
          <DateRange
            editableDateInputs={true}
            onChange={(item) => setDateRange([item.selection])}
            moveRangeOnFirstSelection={false}
            ranges={dateRange}
            rangeColors={["#FF6A3A"]}
          />
        )}

        <Modal.Footer>
          <div className="flex gap-3">
            <button
              className="text-white bg-[#ff6a3a] hover:bg-[#d85e39] rounded py-2 px-7"
              onClick={() => {
                const startDate = new Date(dateRange[0].startDate);
                const endDate = new Date(dateRange[0].endDate);
                startDate.setHours(0, 0, 0, 0);
                endDate.setHours(23, 59, 59, 0);

                props.setState([
                  { ...dateRange[0], startDate: startDate, endDate: endDate },
                ]);
                onClose();
              }}
            >
              Done
            </button>
            <button
              className=" border rounded py-2 px-7 hover:bg-[#c700001a] hover:text-red-600"
              onClick={() => {
                onClose();
                setDateRange(props.state);
              }}
            >
              Cancel
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

DatePicker.prototype = {
  state: PropTypes.array,
};

export default DatePicker;
